var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{staticClass:"profile-gtm"},[_c('c-button',{staticClass:"button profile",attrs:{"data-cy":"profile-menu-button","size":"lg","icon":"user"}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/poi/node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3767c749","hasScoped":false,"transformToRequire":{"img":"src","image":"xlink:href","cimage":"placeholder","c-image":"placeholder","CImage":"placeholder"},"buble":{"transforms":{}}}!./node_modules/poi/node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Layout/Navbar/ProfileGtmNavbar.vue
// module id = 2098
// module chunks = 1611